import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../../components/common/Section';

// 定义缺失的样式组件
const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const FeatureCard = styled.div`
  background-color: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 1.5rem;
  box-shadow: ${props => props.theme.shadows.small};
  transition: transform ${props => props.theme.transitions.fast};
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: ${props => props.theme.shadows.medium};
  }
`;

const FeatureTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.primary};
`;

const FeatureDescription = styled.p`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
`;

const DAM = () => {
  const { t } = useTranslation();
  
  const features = [
    {
      title: t('products.dam.features.storage'),
      description: '提供安全的云存储解决方案，保护您的数字资产不受未授权访问和数据丢失。'
    },
    {
      title: t('products.dam.features.organization'),
      description: '通过元数据、标签和自定义分类法，智能组织和分类数字资产。'
    },
    {
      title: t('products.dam.features.search'),
      description: '强大的搜索功能，支持关键词、元数据、视觉相似性等多种搜索方式。'
    },
    {
      title: t('products.dam.features.version'),
      description: '自动跟踪资产的版本历史，轻松回滚到之前的版本。'
    },
    {
      title: t('products.dam.features.rights'),
      description: '管理数字资产的使用权限和许可，确保合规使用。'
    }
  ];
  
  return (
    <>
      <Section 
        title={t('products.dam.title')} 
        subtitle={t('products.dam.subtitle')}
      >
        <p>{t('products.dam.content')}</p>
        
        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </Section>
    </>
  );
};

export default DAM;